/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Characternamesola2Inputs */



/**
* | output |
* | --- |
* | "Sola" |
*
* @param {Characternamesola2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const characternamesola2 = /** @type {((inputs?: Characternamesola2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Characternamesola2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sola")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sola")
	return /** @type {LocalizedString} */ ("Сола")
});
export { characternamesola2 as "characterNameSola" }